import React, {useEffect,useState} from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { getMuscleGroups, addMuscleGroup, editMuscleGroup, deleteMuscleGroup,removeMuscleGroups,getLibraryExercises } from '../exerciseList/exerciseListSlice.js';
import { Button, Col, Form, Modal, Row, Table, Spinner } from 'react-bootstrap';
import {useHistory} from 'react-router-dom';
import './MuscleGroups.css';
import useCurrentUser from '../../hooks/useCurrentUser'
import useApiStatusDispatch from '../../hooks/useApiStatusDispatch.js';
import CopyModal from './CopyModal'

function MuscleGroups() {

  const dispatch = useDispatch()
  const statusDispatch = useApiStatusDispatch()
  const history = useHistory()
  const user = useCurrentUser()
  const muscleGroupStatus = useSelector((state) => state.exercise.exerciseListStatus)
  const isClient = useSelector((state) => state?.users?.current_user?.account_type) === 'client'

  const isChain = user.account_type === 'chain'

  const isOwner = (
    parseInt(user?.gym_id) !== 0 ?
    user?.account_type === 'gym':
    user?.account_type === 'trainer'
  ) || isChain


  const user_id = useSelector( state => state?.users?.current_user?.user_id_number )

  const [addName, setAddName] = useState("")
  const [showAddModal, setShowAddModal] = useState(false);
  const [editName, setEditName] = useState("")
  const [editMuscle, setEditMuscle] = useState({})
  const [showEditModal, setShowEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false)

  const [selected, setSelected] = useState({})

  const [showCopyModal,setShowCopyModal] = useState(false)
  const [toCopy,setToCopy] = useState({})

  const handleAddModalClose = () => {
    setShowAddModal(false)
    setAddName("")
  }

  const handleEditModalClose = () => {
    setShowEditModal(false)
    setEditName("")
    setEditMuscle({})
  }

  useEffect(() => {
    dispatch(getMuscleGroups({user_id:user_id}))
  },[])

  //grabs muscles object from store, converts to array then alphabetizes
  let muscles = (Object.values(useSelector((state) => state.exercise?.muscles.entities))).sort(function(a,b){
    let textA = a.muscle_group.toUpperCase();
    let textB = b.muscle_group.toUpperCase();
    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
  })

  //shows edit modal, sets placeholder as muscles previous name and sets the edit muscle to grab id later
  const handleEditModalShow = (muscle) => {
    setShowEditModal(true)
    setEditName(muscle.muscle_group)
    setEditMuscle(muscle)
  }

  //grabs id from state then dispatches edit muscle group
  const handleEditMuscle = () => {
    const payload = {
      name: editName,
      id: editMuscle.muscle_id,
      defaultItem: isDefaultMuscle(editMuscle.user_id_number),
      user_id:user_id
    }
    setIsLoading(true)
    dispatch(editMuscleGroup(payload))
    .then(() => {
      dispatch(getLibraryExercises({tgt_user_id_number:user.user_id_number}))
      dispatch(getMuscleGroups({user_id:user_id})).then(() => {
        setShowEditModal(false)
        setIsLoading(false)
      })
    })
  }

  //grabs name from state then dispatches add, then hides modal and resets add name
  const handleAddMuscle = () => {
    const payload={
      name:addName,
      user_id:user_id
    }
    dispatch(addMuscleGroup(payload))
    .then(() => {
      dispatch(getLibraryExercises({tgt_user_id_number:user.user_id_number}))
      dispatch(getMuscleGroups({user_id:user_id})).then(() => {
        setShowAddModal(false)
        setAddName("")
      })

    })
  }

  const isDefaultMuscle = (id) => {
    if(id != 999999){
      return 0
    } else {
      return 1
    }
  }

  const deleteHandler = (muscle) => {
    const payload = {
      id: parseInt(muscle.muscle_id),
      defaultItem: isDefaultMuscle(muscle.user_id_number),
      user_id:user_id
    }
    if (window.confirm('Are you sure you want to delete this muscle group and all the data associated with it?')) {
			dispatch(deleteMuscleGroup(payload))
		}
  }

	//upon the delete checkbox click, deep copies the selected list then either adds or removes the checked(or unchecked) muscle groups
	const handleDeleteToggle =(muscle) => {
    let newSelected = JSON.parse(JSON.stringify(selected))
    if(selected[muscle.muscle_id] !== undefined){
      delete newSelected[muscle.muscle_id]
    } else {
      newSelected[muscle.muscle_id] = muscle
    }
    setSelected(newSelected)
  }

  // when user clicks the garbage can icon, it finds client ID, notifies user then 
  // deletes each  muscle groups that is in the selected state and resets the selected state
  const handleDeleteMuscles = () => {
    if (window.confirm('Are you sure you want to delete the selected muscle groups and all the data associated with them?')) {
      const muscle_ids = Object.values(selected).map(muscle => muscle.muscle_id)
      dispatch(removeMuscleGroups(muscle_ids))
      setSelected({})
    }
  }

  // when a user clicks the delete all checkbox, either unchecks everything if already checked
  // or checks everything if none or some  muscle groups are checked
  const toggleDeleteAll = () => { 
    if(Object.keys(selected).length === muscles.length){
      setSelected({})
    } else {
      let newSelected = {}
      muscles.forEach(muscle => (
        newSelected[muscle.muscle_id] = muscle
      ))
      setSelected(newSelected)
    }
  }

  // checks if a  muscle group id is within the selected object
  const inDeleteList = (id) => {
      if(selected[id] !== undefined){
        return true
      } else {
        return false
      }
  }

  //navigates back to the exersize list page
  const handleGotoExercises = () => {
    history.push('/exerciseList')
  }

  if (isClient) return null

  return(
    <div id="containerDiv">
      <div className='muscleGroupTable  px-2 px-md-3'>
        <div className="pt-2">
          <div className="d-flex">
            <strong style={{lineHeight:"1.5"}}>Muscle Groups</strong>
            <Button size="sm" className="ml-auto" variant="outline-success" onClick={() => setShowAddModal(true)} style={{marginLeft:'25px', float:'right'}} >
              Add Muscle Group
            </Button>
            <Button size="sm" variant="outline-primary" onClick={handleGotoExercises} className="ml-1">
              Back To Exercises
            </Button>
          </div>
          {(!isOwner&&!isClient)&&
            <span>
              <strong>Note:</strong> You can add muscle groups but only the gym owner is allowed to edit and delete muscle groups.
            </span>
          }
        </div>
        <Table striped bordered hover className="muscleListTable">
            <thead>
                <tr>
                    <th>Muscle Group</th>

                    <th>
                      {isOwner&&
                        <div className="d-flex align-items-center" style={{float:'right'}}>
                          <Button 
                            disabled={Object.keys(selected).length === 0}
                            onClick={handleDeleteMuscles} 
                            variant="danger"
                            size="sm">
                            <i className="fa fa-trash"/>
                          </Button>
                          {isChain&&
                             <Button 
                                disabled={Object.keys(selected).length === 0}
                                onClick={()=>{
                                  setShowCopyModal(true)
                                }}
                                className="ml-2"
                                variant="primary" 
                                size="sm"
                              >
                                Copy <i className="fa fa-copy"/>
                              </Button>
                          }
                          <Form.Check
                            className="ml-3"
                            onChange={toggleDeleteAll}
                            checked={Object.keys(selected).length === muscles.length}
                            type="checkbox"
                            aria-label="check all"
                          />
                        </div>
                      }
                    </th>
                    {/* <th>&#x2715;</th> */}

                </tr>
            </thead>
            {muscleGroupStatus==='fetching'? 
              <Spinner animation="border" role="status" variant="primary" >
              </Spinner>
            :
            null}
            <tbody>
              {muscles.map(muscle => (
                <tr >
                  <td 
                    onClick={(e) =>{
                      if(!isOwner) return
                      handleEditModalShow(muscle)
                    }} 
                    style={{cursor: isOwner ? "pointer" : 'auto'}}
                  >
                    {muscle.muscle_group}
                  </td>

                  <td>
                    {isOwner&&
                      <Form.Check
                        onChange={()=>handleDeleteToggle(muscle)}
                        checked={(inDeleteList(muscle.muscle_id))}
                        style={{float:'right'}}
                        type="checkbox"
                        aria-label="check all"
                      />
                    }
                  </td>
                </tr>
              ))}
            </tbody>
        </Table>
      </div>

      <Modal
        keyboard={false}
        show={showAddModal}
        onHide={handleAddModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add New Muscle Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Group as={Row} >
                    <Form.Label column sm="5">
                        Muscle Group
                    </Form.Label>
                    <Col sm="6">
                        <Form.Control type="text" placeholder="Group Name" onChange={(e) =>setAddName(e.target.value)} />
                    </Col>
                </Form.Group>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="danger" onClick={handleAddModalClose}>
                Cancel
            </Button>
            <Button variant="success" onClick={handleAddMuscle}>
                Submit
            </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        keyboard={false}
        show={showEditModal}
        onHide={handleEditModalClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit a Muscle Group</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <Form.Group as={Row} >
                    <Form.Label column sm="5">
                        Muscle Group
                    </Form.Label>
                    <Col sm="6">
                        <Form.Control type="text" value={editName} onChange={(e) =>setEditName(e.target.value)} />
                        {/* <Form.Control type="text" placeholder={editName} onChange={(e) =>setEditName(e.target.value)} /> */}
                    
                    </Col>
                </Form.Group>
            </Form>
        </Modal.Body>
        {isLoading ? 
          <Modal.Footer>
            <Spinner animation="border" variant="primary"  style={{textAlign: "center"}}  />
          </Modal.Footer>
          :
          
        
          <Modal.Footer>
              <Button variant="danger" onClick={handleEditModalClose}>
                  Cancel
              </Button>
              <Button variant="success" onClick={handleEditMuscle}>
                  Submit
              </Button>
          </Modal.Footer>
        }
      </Modal>
      <CopyModal
        show={showCopyModal}
        onHide={()=>{ setShowCopyModal(false) }}
        muscle_ids={Object.keys(selected)}
      />
    </div>
  )
}

export default MuscleGroups